import { dmApi } from "../../app/dmApi";
import { getAuthorizationHeader, handleQueryError } from "../../helpers/RtkQueryUtils";
import { serialize } from "../../helpers/Utils";



export const receivingApi = dmApi.injectEndpoints({

    endpoints: (build) => ({
        getReceivingOverview: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/overview?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(), 
                }
            },
            providesTags : ['receivingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),
    }),

});

export const {
useGetReceivingOverviewQuery
} = receivingApi;